<template>
  <download-csv :data="dataCSV" :name="nameCSV">
    <v-btn
      :small="size == 'small'"
      :medium="size == 'medium'"
      :disabled="false || load"
      :text="typeButton === 'text'"
      :outlined="typeButton === 'outlined'"
      @click="execute"
      :color="csvColor"
    >
      <v-icon v-if="icon && alignIcon" left>{{ icon }}</v-icon>
      {{ text }}
      <v-icon v-if="icon && !alignIcon" right>{{ icon }}</v-icon>
    </v-btn>
  </download-csv>
</template>

<script>
const props = {
  text: {
    default: "Descargar",
    type: String,
  },
  onClick: Function,
  icon: {
    default: "mdi-microsoft-excel",
    type: String,
  },
  typeButton: {
    default: "text",
    type: String,
  },
  downloadType: {
    default: "",
    type: String,
  },
  csvColor: {
    default: null,
    type: String,
  },
  alignIcon: {
    default: false,
    type: Boolean,
  },
  dataCSV: Array,
  nameCSV: {
    default: "Documento",
    type: String,
  },
  size: {
    default: "small",
    type: String,
  },
  load: {
    default: false,
    type: Boolean,
  },
};

export default {
  methods: {
    execute() {
      if (this.onClick) {
        this.onClick(this.downloadType);
      }
    },
  },
  props: props,
};
</script>

<style scoped></style>
